import React from "react"

import { forceArray } from "../../../config/util-functions"

export default ({ children, ...rest }) => (
    <div className="col-12 col-xl-6 item-details-column" {...rest}>
        {forceArray(children).map((child, index) => {
            if (!child) {
                return null
            }
            const containerClassName = "widget-bottom-margin item-detail-panel"
            if (child.type === "div") {
                return (
                    <div
                        key={index}
                        {...child.props}
                        className={`${child.props.className ||
                            ""} ${containerClassName}`}
                    >
                        {child.props.children}
                    </div>
                )
            } else {
                return (
                    <div key={index} className={containerClassName}>
                        {child}
                    </div>
                )
            }
        })}
    </div>
)
